import React from 'react';
import { useSelector } from 'react-redux';

export default function usePayableSelector() {
  const PayableListData = useSelector((state) => state?.Payable?.list_data?.content) || []; // view data
  const PayableViewData = useSelector((state) => state?.Payable?.view_data) || []; // view data
  console.log('✅ Payable List Data in selector rrrrr', PayableListData);
  console.log('✅ Payable View Data in selector rrrrr', PayableViewData);
  return { PayableListData, PayableViewData };
}
